import { Tag } from 'antd';
import React from 'react';

const campaignStatus = {
  draft: 'Rascunho',
  published: 'Publicado'
};

const CampaignStatusTag = ({ status }) => {
  const color = status === 'published' ? 'green' : undefined;
  return (
    <Tag color={color} className="gx-mb-0">
      {campaignStatus[status]}
    </Tag>
  );
};

export default CampaignStatusTag;
